import http from 'services/http-service';

const AuthorService = {
    GetAll() {
        var response = http.get("/authors");
        return response;
    }
};

export default AuthorService;